import { formatDateForInput, formatTodayForDateInput } from "./formatDateForInput";

/** True when admin "Early bird pricing" is enabled for the event (matches ManageEvents toggle). */
export function isEventEarlyBirdConfigured(event: {
  earlyBirdPrice?: number | null;
  earlyBirdDateEnd?: string | null;
}): boolean {
  const ebPrice = event.earlyBirdPrice ?? 0;
  const ebEndFormatted = formatDateForInput(event.earlyBirdDateEnd);
  const hasActiveEarlyBirdEnd =
    !!ebEndFormatted &&
    ebEndFormatted !== "1970-01-01" &&
    ebEndFormatted >= formatTodayForDateInput();
  return ebPrice > 0 || hasActiveEarlyBirdEnd;
}
